import { AssetClass } from "types/AssetClass";
import { YieldPerTimespan } from "types/YieldPerTimespan";
import { createCustomAction } from "typesafe-actions";

const YIELDPERTIMESPAN_DATA_LOAD = "YIELDPERTIMESPAN/YIELDPERTIMESPAN_DATA_LOAD";
const YIELDPERTIMESPAN_DATA_LOAD_SUCCESS = "YIELDPERTIMESPAN/YIELDPERTIMESPAN_DATA_LOAD_SUCCESS";
const YIELDPERTIMESPAN_DATA_LOAD_FAIL = "YIELDPERTIMESPAN/YIELDPERTIMESPAN_DATA_LOAD_FAIL";

export type YieldPerTimespanContentType = "all" | keyof typeof AssetClass;

export const load = createCustomAction(
  YIELDPERTIMESPAN_DATA_LOAD,
  (type) => (contentType: YieldPerTimespanContentType) => ({
    type,
    contentType,
  })
);

export const loadSuccess = createCustomAction(
  YIELDPERTIMESPAN_DATA_LOAD_SUCCESS,
  (type) => (contentType: YieldPerTimespanContentType, data?: YieldPerTimespan[]) => ({
    type,
    contentType,
    data,
  })
);

export const loadFail = createCustomAction(
  YIELDPERTIMESPAN_DATA_LOAD_FAIL,
  (type) => (contentType: YieldPerTimespanContentType, error?: string) => ({
    type,
    contentType,
    error,
  })
);
